import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DocumentsComponent} from './documents.component';
import {IwgcommonModule} from '../iwgcommon/iwgcommon.module';
import {RouterModule} from '@angular/router';
import {MaterialModule} from '../shared/material/material.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {AppRoutingModule} from '../app-routing.module';
import {FormsModule} from '@angular/forms';
import {AssignmentsModule} from '../assignments/assignments.module';
import {CountryGuidesModule} from '../country-guides/country-guides.module';
import {SharedPipesModule} from '../shared/pipes/sharedpipes.module';
import {QuotesService} from '../shared/services/quotes.service';
import {CountryService} from '../shared/services/country.service';
import { DocumentsTableComponent } from './documents-table/documents-table.component';


@NgModule({
  declarations: [DocumentsComponent, DocumentsTableComponent],
  imports: [
  CommonModule,
  MaterialModule,
  IwgcommonModule,
  FlexLayoutModule,
  AppRoutingModule,
  FormsModule,
  AssignmentsModule,
  CountryGuidesModule,
  SharedPipesModule,


],
providers: [ CountryService]
})
export class DocumentsModule { }
